import ajax from 'Site/js/util/ajax.fetch';
import router from 'Profile/js/router';
import store from 'Site/js/store';
import Vue from 'vue';
import 'Groups/scss/groups.scss';
import VueRouter from 'vue-router';
import profileHeader from 'Profile/mixin/profileHeader';

function invite(e, type) {
    const $el = e.currentTarget;
    const id = $el.getAttribute('data-id');

    ajax.update('groupInvite', { id, accepted: type === 'accept' }).then((response) => {
        store.dispatch('notify', { msg: response.message });

        $el.parentNode.parentNode.removeChild($el.parentNode);
        $el.parents('.invitation').remove();
        if (!document.querySelectorAll('.invitation').length) {
            const $header = document.querySelector('.invitations-header');
            $header.parentNode.removeChild($header);
        }
    }).catch(({ response }) => {
        response.then((error) => {
            store.dispatch('notify', { msg: error.message, type: 'error' });
        });
    });
}

export default function () {
    Vue.use(VueRouter);

    new Vue({ /* eslint no-new: 0 */
        el: '#profile-vue',
        router,
        store,
        mixins: [profileHeader],
    });

    const $accept = document.querySelector('.invite-accept');
    if ($accept) {
        $accept.addEventListener('click', (e) => { invite(e, 'accept'); });
    }
    const $decline = document.querySelector('.invite-decline');
    if ($decline) {
        $decline.addEventListener('click', (e) => { invite(e, 'decline'); });
    }

    let settings = document.querySelector('#groups-json').textContent;
    if (settings) {
        settings = JSON.parse(settings);
    }
}
